import { render } from "./App.vue?vue&type=template&id=2db9f1bc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2db9f1bc&lang=css"

import exportComponent from "C:\\Users\\reddy\\Desktop\\win.backbenchers.org.in\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__